module.exports = __webpack_public_path__ + "static/img/MDE.a0ef26d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MDE.png
// module id = blqB
// module chunks = 34